import React from "react";
import { Loader, LoaderProps } from "rsuite";
export const Spinner = (props: LoaderProps) => {
  return <Loader size={props.size} {...props} data-sentry-element="Loader" data-sentry-component="Spinner" data-sentry-source-file="index.tsx" />;
};